import React, { useState } from 'react';
import classnames from 'classnames';
import Link from 'next/link';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap_white.css';
// import { useRequest } from 'ahooks';
import dynamic from 'next/dynamic';
import { TEL_MOBILE, wechatQR } from '@/constants/global';
// import CBNDataLogo from 'assets/cbndata_logo.svg';
import styles from './index.module.scss';

const DynamicFeedBack = dynamic(() => import('../feed-back'));

export interface IFooterProps {
  className?: string;
}

export function FooterNormal({ className }: IFooterProps) {
  return (
    <footer className={classnames(className)}>
      <div>如有任何疑问，请咨询平台工作人员</div>
      <div>{TEL_MOBILE}</div>
    </footer>
  );
}

export interface ICopyRightProps {
  isWrap?: boolean;
  center?: boolean;
  className?: string;
}

export function CopyRight({ isWrap = false, center, className }: ICopyRightProps) {
  return (
    <p className={classnames(styles.copyRight, className, { 'text-center': center || isWrap })}>
      &copy;上海第一财经数据科技有限公司 {isWrap && <br />}沪ICP备15026457号-5
    </p>
  );
}

const qrcodeOptions = [
  {
    render: () => (
      <svg className="icon" aria-hidden="true">
        <use xlinkHref="#icon-weibo"></use>
      </svg>
    ),
  },
  {
    render: () => (
      <svg className="icon" aria-hidden="true">
        <use xlinkHref="#icon-wechat"></use>
      </svg>
    ),
  },
  // {
  //   render: () => (
  //     <svg className="icon" aria-hidden="true">
  //       <use xlinkHref="#icon-a-miniprogramicon"></use>
  //     </svg>
  //   ),
  // },
];

export const QrcodeContent = index => {
  switch (index) {
    case 0:
      return (
        <div className={classnames('flex-row-nowrap', 'flex-center-center', styles.qrcodeSection)}>
          <div className={classnames('flex-column-nowrap', 'flex-center-center', styles.qrcodeContent)} key={index}>
            <img src="//assets-oss.cbndata.com/cbndata-web/logo/FroP3gm0CNRKJuX44pPlAoSD8v2N.png" width="105" />
            <div className={styles.codeItemName}>@第一财经商业数据中心</div>
          </div>
          {/* <div className={classnames('flex-column-nowrap', 'flex-center-center', styles.qrcodeContent)} key={index}>
            <img width="80px" src="//assets-oss.cbndata.com/cbndata-web/logo/FnKSL6t1dFNp7xxdpDtO_mO3PmS3.png" />
            <div className={styles.codeItemName}>@第一财经商业数据中心</div>
          </div> */}
        </div>
      );
    case 1:
      return (
        <div className={classnames('flex-row-nowrap', 'flex-center-center', styles.qrcodeSection)}>
          <div className={classnames('flex-column-nowrap', 'flex-center-center', styles.qrcodeContent)} key={index}>
            <img
              width="80px"
              height="80px"
              src="//assets-oss.cbndata.com/cbndata-refactor-fe/FnigHdyYQ2uZrY5JFGtMvK0HeId-.png"
            />
            <div className={styles.codeItemName}>@CBNData消费站</div>
          </div>
          <div className={classnames('flex-column-nowrap', 'flex-center-center', styles.qrcodeContent)} key={index}>
            <img
              width="80px"
              height="80px"
              src="//assets-oss.cbndata.com/cbndata-refactor-fe/FnigHdyYQ2uZrY5JFGtMvK0HeId-.png"
            />
            <div className={styles.codeItemName}>@第一财经商业数据中心</div>
          </div>
          <div className={classnames('flex-column-nowrap', 'flex-center-center', styles.qrcodeContent)} key={index}>
            <img
              width="80px"
              height="80px"
              src="//assets-oss.cbndata.com/cbndata-refactor-fe/FmuJb6KYxvd5zLF0hROdM4GNkFqB.png"
            />
            <div className={styles.codeItemName}>@消费新探</div>
          </div>
          <div className={classnames('flex-column-nowrap', 'flex-center-center', styles.qrcodeContent)} key={index}>
            <img
              width="80px"
              height="80px"
              src="//assets-oss.cbndata.com/cbndata-refactor-fe/Fk2fQjScRIC1VTOEYeB-_VMlYNjJ.png"
            />
            <div className={styles.codeItemName}>@星数</div>
          </div>
          <div className={classnames('flex-column-nowrap', 'flex-center-center', styles.qrcodeContent)} key={index}>
            <img
              width="80px"
              height="80px"
              src="//assets-oss.cbndata.com/cbndata-refactor-fe/Fg5VaUYDdKocnxt_xszOzXqFcmMK.png"
            />
            <div className={styles.codeItemName}>@红漏斗</div>
          </div>
        </div>
      );
    case 2:
      return (
        <div className={classnames('flex-row-nowrap', 'flex-center-center', styles.qrcodeSection)}>
          <div className={classnames('flex-column-nowrap', 'flex-center-center', styles.qrcodeContent)} key={index}>
            <img
              width="80px"
              height="80px"
              src="//assets-oss.cbndata.com/cbndata-web/Downloads/FqgX0H1Q4Oa4sENGG3rnOtKalxHt.jpg"
            />
            <div className={styles.codeItemName}>@CBNDatabox</div>
          </div>
        </div>
      );
    default:
      return <></>;
  }
};

const ConactUs = () => (
  <div className={styles.ConactUs}>
    {/* <CBNDataLogo /> */}
    <img src="//assets-oss.cbndata.com/cbndata-web/logo/FroP3gm0CNRKJuX44pPlAoSD8v2N.png" style={{ width: '105px' }} />
    <div className={classnames('flex-row-nowrap', 'flex-around-center', styles.qrcodesContainer)}>
      {qrcodeOptions.map((item, index) => (
        <Tooltip
          placement="top"
          trigger={['hover']}
          overlay={QrcodeContent(index)}
          overlayClassName={styles.footerTooltip}
          key={index}
        >
          <div className={classnames(styles.qrcodeFocus)}>{item.render()}</div>
        </Tooltip>
      ))}
    </div>
  </div>
);

export default function Footer() {
  const [feedBackVisible, setFeedBackVisible] = useState(false);
  // const data = [];
  return (
    <footer className={classnames('flex-column-nowrap', 'flex-between-start', styles.footerSection)}>
      <div className={styles.brandSection}>
        <div className={classnames('flex-row-nowrap', 'flex-center-center', styles.brandContent)}>
          <span className={styles.brandPartnerText}>数据合作方：</span>
          <div className={classnames('flex-row-nowrap', 'flex-start-center', styles.logoContainer)}>
            <a href="https://www.bailian-ai.com/product/ddt" target={'_blank'} rel="noreferrer">
              <img
                src="//assets-oss.cbndata.com/cbndata-consume-brand/logos/bailian_ai.svg"
                alt="百炼智能"
                width="115"
                height="56"
              />
            </a>
            <a href="https://www.nint.com/information" target={'_blank'} rel="noreferrer">
              <img
                src="//assets-oss.cbndata.com/cbndata-consume-brand/logos/nint.svg"
                alt="任拓情报通"
                width="115"
                height="56"
              />
            </a>
            <a href="https://yqt.midu.com/" target={'_blank'} rel="noreferrer">
              <img
                src="//assets-oss.cbndata.com/cbndata-consume-brand/logos/sina.svg"
                alt="新浪舆情通"
                width="115"
                height="56"
              />
            </a>
            <a href="https://www.tianyancha.com/" target={'_blank'} rel="noreferrer">
              <img
                src="//assets-oss.cbndata.com/cbndata-consume-brand/logos/tianyancha.svg"
                alt="天眼查"
                width="115"
                height="56"
              />
            </a>
            <a href="https://www.qian-gua.com/" target={'_blank'} rel="noreferrer">
              <img
                src="//assets-oss.cbndata.com/cbndata-consume-brand/logos/qiangua.svg"
                alt="千瓜数据"
                width="115"
                height="56"
              />
            </a>
            <a href="http://wb.xiguaji.com/" target={'_blank'} rel="noreferrer">
              <img
                src="//assets-oss.cbndata.com/cbndata-consume-brand/logos/xiguaji.svg"
                alt="西瓜微数"
                width="115"
                height="56"
              />
            </a>
          </div>
        </div>
      </div>
      <div className={classnames('flex-row-nowrap', styles.footerContent)}>
        <ConactUs />
      </div>
      <div className={styles.record}>
        {feedBackVisible && <DynamicFeedBack visible={feedBackVisible} onCancel={() => setFeedBackVisible(false)} />}
        <a className={styles.recordLink} onClick={() => setFeedBackVisible(true)}>
          意见反馈
        </a>
        <span> | </span>
        <Tooltip
          placement="top"
          trigger={['hover']}
          overlay={
            <div className={classnames('flex-column-nowrap', 'flex-center-center', styles.connactUs)}>
              <img width="80px" height="80px" src={wechatQR} />
              <div className={styles.codeItemName}>@CBNData消费站</div>
            </div>
          }
          overlayClassName={styles.footerTooltip}
        >
          <span className={styles.recordLink}>联系客服</span>
        </Tooltip>
        <span> | </span>
        <Link href="/about" prefetch={false}>
          <a className={styles.recordLink} target="_blank" rel="noreferrer">
            关于中国新消费品牌库
          </a>
        </Link>
      </div>
      <div className={styles.record}>
        <a className={styles.recordLink} href="/copyright" target="_blank">
          ©上海应帆数字科技有限公司
        </a>
        <span> | </span>
        <a className={styles.recordLink} href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">
          沪ICP备15026457号-5
        </a>
        <span> | </span>
        <a className={styles.recordLink} href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">
          沪公网安备11000002000001
        </a>
      </div>
    </footer>
  );
}
